const ExpandButtonOnlyRole = ({ elemId, count = 0, isActive = false }) => {
  if (count === 0) return "";

  const arrowIcon = isActive ? "keyboard_arrow_up" : "keyboard_arrow_down";

  return (
    `<button class="role-toggle-button${isActive ? " active" : ""}"` +
    ` type="button" data-role-id="${elemId}">` +
    // '<i class="material-icons role-toggle-icon">group</i>' +
    `<span class="role-toggle-count">${count}</span>` +
    `<i class="material-icons role-toggle-arrow">${arrowIcon}</i>` +
    "</button>"
  );
};

export default ExpandButtonOnlyRole;
